import type {SketchGroup} from '../sketch/SketchGroup';
import {hasRuntimeFlag} from './hasRuntimeFlag';

/**
 * 判断对象是否为 SketchGroup 实例。
 * @param value 待判断对象。
 * @returns 当对象满足草图组协议时返回 true。
 */
export function isSketchGroup(value: unknown): value is SketchGroup {
    return hasRuntimeFlag(value, 'isSketchGroup');
}
